import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getSalesOrdersList = (customer_id, profile_id, page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/inquiry-salesorder/', {
    headers: authHeader(),
    params: {
      customer_id: customer_id,
      profile_id: profile_id,
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};


const getArchiveSalesOrderList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/inquiry-salesorder-archive', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};

const getSalesOrderById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/inquiry-salesorder/${id}`, {
    headers: authHeader()
  });
};


const addQuotationToSalesOrder = (id, formData) => {
  
  return axios.post(
    `${API_URL}/api/${API_VERSION}/inquiry-quotation/${id}/convert-to-salesorder/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};

const addSalesOrder = (id, formData) => {
  
  return axios.post(
    `${API_URL}/api/${API_VERSION}/inquiry-salesorder/`,
    formData, // Payload for the request body
    { headers: authHeader() },
  );
};



const editSalesOrder = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/inquiry-salesorder/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};

const archiveSalesOrder = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/inquiry-salesorder/${id}/`,
    { headers: authHeader() }, // Authentication header
  );
};
const unArchiveSalesOrder = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/inquiry-salesorder/${id}/unarchive/`,
    {},
    { headers: authHeader() }, 
  );
};

const salesOrderService = {
  getSalesOrdersList,
  getArchiveSalesOrderList,
  getSalesOrderById,
  addQuotationToSalesOrder,
  addSalesOrder,
  editSalesOrder,
  archiveSalesOrder,
  unArchiveSalesOrder,
};

export default salesOrderService;
